import { render, staticRenderFns } from "./filiale.vue?vue&type=template&id=41620b57&"
import script from "./filiale.vue?vue&type=script&lang=js&"
export * from "./filiale.vue?vue&type=script&lang=js&"
import style0 from "./filiale.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports